exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "::-webkit-input-placeholder{color:#666}:-moz-placeholder,::-moz-placeholder{color:#666}:-ms-input-placeholder{color:#666}textarea::-webkit-input-placeholder{color:#666}textarea:-moz-placeholder,textarea::-moz-placeholder{color:#666}textarea:-ms-input-placeholder{color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-8006fba2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 149
// module chunks = 0